var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.256 1.065a.75.75 0 1 0-1.5 0v5.44a.75.75 0 0 0 1.5 0zm-3.06 2.527a.75.75 0 0 0-.833-1.247 5.646 5.646 0 1 0 6.274 0 .75.75 0 1 0-.833 1.247 4.146 4.146 0 1 1-4.607 0",
  clipRule: "evenodd"
})));
export default SvgIcoLogout;